const isMentionTextAt = (blockText, position, trigger) => {
  const str = blockText.substr(0, position);
  const lastStr = blockText.substr(position);
  const aPartOfMentionRegex = /[a-zA-Z.\s]*(})/i;
  const matchResult = lastStr.match(aPartOfMentionRegex);
  if (typeof matchResult !== 'undefined' && matchResult !== null) {
    return true;
  }
  return false;
};

export default (editorState, selection, trigger) => {
  const anchorKey = selection.getAnchorKey();
  const anchorOffset = selection.getAnchorOffset();
  const currentContent = editorState.getCurrentContent();
  const currentBlock = currentContent.getBlockForKey(anchorKey);
  const blockText = currentBlock.getText();
  return isMentionTextAt(blockText, anchorOffset, trigger);
};
